import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalService } from '../../services/global.service';

@Injectable({
  providedIn: 'root',
})
export class UnauthorizedGuard {
  isAllFormSubmitted: boolean | unknown = false;
  constructor(
    private router: Router,
    private globalService: GlobalService,
  ) {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      this.globalService.whoAmI(`${token}`).subscribe({
        next: (result) => {
          this.isAllFormSubmitted = result.body?.isAllFormSubmitted;
        },
        error: (error) => {
          console.error(error);
        },
      });
    }
  }

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = sessionStorage.getItem('accessToken');
    if (token && this.isAllFormSubmitted) {
      this.router.navigate(['/dashboard']);
      return false;
    } else {
      return true;
    }
  }
}
